import Tooltip from 'rc-tooltip';

import 'rc-tooltip/assets/bootstrap.css';

export default Tooltip;
